import { Component, input, output } from '@angular/core';
import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconChevronLeft, homefieldIconChevronRight } from '@dsg-tech/homefield-angular-icons';

import { NgClass } from '@angular/common';

@Component({
    selector: 'plp-components-carousel-button',
    imports: [NgClass, HomefieldIconLibraryModule],
    templateUrl: './carousel-button.component.html',
    styleUrls: ['./carousel-button.component.scss']
})
export class CarouselButtonComponent {
	label = input('');
	previous = input(false);
	showLeftArrow = input(false);
	showRightArrow = input(false);

	clickEvent = output<boolean>();

	constructor(private readonly homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconChevronLeft,
			homefieldIconChevronRight
		]);
	}

	onClick() {
		this.clickEvent.emit(this.previous());
	}
}
